var render = function render(){var _vm=this,_c=_vm._self._c;return (this.params.data)?_c('div',{staticClass:"item-style"},[_c('div',[_vm._v("\n    "+_vm._s(this.params.data.Name)),_c('br'),_vm._v("\n    "+_vm._s(this.params.data.Address)),_c('br'),_vm._v("\n    "+_vm._s(this.params.data.PostalCode)+" "+_vm._s(this.params.data.City)+" ("+_vm._s(this.params.data.CountryId)+")"),_c('br')])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }